import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { SvgLoader } from "react-svgmt";
import { Helmet } from "react-helmet";

import { Loading } from "./utils";

const Toplist = (props) => {
  const region = props.match.params.region;
  const leagues = { jp: "ljl", kr: "lck" };
  const league = leagues[region];
  const title = league.toUpperCase() + " Player's Toplist";
  const [data, setData] = useState({});

  useEffect(() => {
    (async () => {
      const res = await fetch(
        "https://script.google.com/macros/s/" +
          process.env.REACT_APP_SHEET_ID +
          "/exec?q=" +
          league
      );
      const json = await res.json();
      setData(json);
    })();
  }, [league]);

  return (
    <div className="common-bg-grey">
      <Helmet
        title={title}
        meta={[
          { name: "twitter:card", content: "summary" },
          {
            property: "og:url",
            content:
              "https://sightstones.netlify.app" + props.location.pathname,
          },
          { property: "og:title", content: title },
          {
            property: "og:image",
            content: "https://sightstones.netlify.app/img/ogp.png",
          },
        ]}
      />
      <Container className="toplist bg-white">
        <header>
          <p className="text-right">Last Update: {data.updated}</p>
          <h1 className="my-5 h2 text-center">{title}</h1>
        </header>
        <Row>
          {!Object.keys(data).length ? (
            <Loading />
          ) : (
            <>
              <Col lg={8}>
                <MainToplist teams={data.teams} standings={data.standings} />
              </Col>
              <Col lg={4}>
                <RankToplist players={data.ranks} />
                <GamesToplist players={data.games} />
                <WinrateToplist players={data.winrates} />
              </Col>
            </>
          )}
        </Row>
      </Container>
    </div>
  );
};

const MainToplist = (props) => {
  const TierIcon = (rank) => {
    const tier = rank.match(/([A-Z]+)?\s?/)[1].toLowerCase();
    if (tier === "unranked") {
      return "";
    }
    return (
      <img
        src={`/rank/${tier}.png`}
        width="16px"
        height="16px"
        alt={tier}
        className="mr-2"
      />
    );
  };

  return (
    <>
      {props.standings.map((team) => (
        <section key={team}>
          <h2 className="mb-1 p-1 h4 common-f-blue">{team}</h2>
          <Table size="sm" className="toplist-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>IGN</th>
                <th>Rank</th>
                <th>Win/Lose</th>
              </tr>
            </thead>
            <tbody>
              {props.teams[team].map((player) => (
                <tr key={player.name}>
                  <td>
                    <SvgLoader
                      path={`/country/${player.country}.svg`}
                      width="16px"
                      height="16px"
                      className="mr-1"
                    />
                    <img
                      src={`/role/${player.role}.png`}
                      width="16px"
                      height="16px"
                      alt={player.role}
                      className="mr-1"
                    />
                    {player.name}
                  </td>
                  <td>
                    <a
                      href={"http://www.op.gg/summoner/userName=" + player.ign}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {player.ign}
                    </a>
                  </td>
                  <td>
                    {TierIcon(player.rank)}
                    {player.rank}
                  </td>
                  <td>
                    {player.games} ({player.winrate}%)
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </section>
      ))}
    </>
  );
};

const RankToplist = (props) => {
  return (
    <>
      <h2 className="mb-1 p-1 h4 common-f-blue">Rank</h2>
      <Table striped size="sm" className="toplist-side">
        <tbody>
          {props.players.map((player, i) => (
            <tr key={player.name}>
              <td>{i + 1}</td>
              <td>{player.name}</td>
              <td>{player.rank}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

const GamesToplist = (props) => {
  return (
    <>
      <h2 className="mb-1 p-1 h4 common-f-blue">Games</h2>
      <Table striped size="sm" className="toplist-side">
        <tbody>
          {props.players.map((player, i) => (
            <tr key={player.name}>
              <td>{i + 1}</td>
              <td>{player.name}</td>
              <td>{player.all}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

const WinrateToplist = (props) => {
  return (
    <>
      <h2 className="mb-1 p-1 h4 common-f-blue">Win Rate</h2>
      <Table striped size="sm" className="toplist-side">
        <tbody>
          {props.players.map((player, i) => (
            <tr key={player.name}>
              <td>{i + 1}</td>
              <td>{player.name}</td>
              <td>{player.winrate}%</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default Toplist;
